<template>

  <Wizard
    class     = "wizard"
    icon      = "mdi-timer-sand"
  >
    <div class="text-h5">

      Loading

      <v-progress-linear
        indeterminate
        color         = "primary"
        height        = "2"
        class         = "mt-1"
      >
      </v-progress-linear>
    </div>

  </Wizard>

</template>

<script lang="js">

// #region Imports

/* Telestream */
import Wizard from '../Wizard';

// #endregion Imports

export default {

  // #region Properties

  name:       'LoadingWizard',
  components: {
    Wizard
  }

  // #endregion Properties

}

</script>